.TagsReadOnly605524272__root {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 6px;
}

.TagsReadOnly605524272__liReadOnly {
    border: 1px solid #acafc4;
    border-radius: 4px;
    padding: 2px 12px;
    background: #fff;
    list-style-type: none;
    cursor: default;
}
/* st-namespace-reference="../../../../src/atoms/SelectionTags/TagsReadOnly.st.css" */